// Browsers can restore a page from back/forward-cache with the DOM exactly as it was when the
// user navigated away -- if a popup was open at that moment, .is-active would still be set on
// restore, making it look like the popup "opens by default" on load. Clearing it defensively on
// both initial load and bfcache restore avoids that.
function closeAllPopups() {
  document.querySelectorAll('.popup-modal-custom.is-active').forEach(function (modal) {
    modal.classList.remove('is-active');
  });
}
closeAllPopups();
window.addEventListener('pageshow', closeAllPopups);

document.addEventListener('click', function (event) {
  const trigger = event.target.closest('.js-popup-trigger');
  if (trigger) {
    const targetSelector = trigger.getAttribute('data-target');
    const modal = targetSelector && document.querySelector(targetSelector);
    if (modal) {
      event.preventDefault();
      modal.classList.add('is-active');
    }
    return;
  }

  const closer = event.target.closest('.js-popup-close');
  if (closer) {
    const modal = closer.closest('.popup-modal-custom');
    if (modal) modal.classList.remove('is-active');
    return;
  }

  if (event.target.classList.contains('popup-modal-custom')) {
    event.target.classList.remove('is-active');
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.popup-modal-custom.is-active').forEach(function (modal) {
    modal.classList.remove('is-active');
  });
});
